import React from 'react';
import { useParams } from 'react-router-dom';
import { Card, SummaryLayout } from 'quanta-ui';
import { Layout, ClientService } from 'quanta-flows/modules/layout';

import {
  initHealthQuoteState,
  initHealthPlansState,
} from 'quanta-flows/modules/quote/health/state';

import QuoteWizard from './quote-wizard';
import QuoteSummary from './quote-summary';
import { IntermediryDetails } from 'quanta-flows/modules/quote/health';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-solid-svg-icons';

export default function CaptureHealthDetails({
  productName,
  productCode,
  lobCode,
  quoteNumber,
}) {
  let nav = ['Quote', 'Get Quote'];
  const product_name = productName
    ? productName
    : useParams().product_name;
  const product_code = productCode
    ? productCode
    : useParams().product_code;
  const lob_code = lobCode ? lobCode : useParams().lob_code;
  const quote_number = quoteNumber ? quoteNumber : undefined;

  if (quote_number === undefined) {
    initHealthQuoteState();
    initHealthPlansState();
  }

  return (
    <Layout
      nav={nav}
      service_type={ClientService}
      title={`Your ${product_name} Quote`}
    >
      <SummaryLayout
        summary={
          <div className="flex flex-col h-auto">
            {/* <Card title="Intermediary">
              <IntermediryDetails />
            </Card> */}
            <Card
              className="xl:mt-4 h-full p-0"
              severity="white"
              title="Quotation"
            >
              <QuoteSummary
                productCode={product_code}
                lobCode={lob_code}
              />
            </Card>
          </div>
        }
        showFloatingSummary={true}
        summaryIcon={<FontAwesomeIcon icon={faSave} size="2x" />}
      >
        <Card className="xl:min-h-full min-h-screen">
          <QuoteWizard
            lobCode={lob_code}
            productName={product_name}
            productCode={product_code}
            quoteNumber={quote_number}
          />
        </Card>
      </SummaryLayout>
    </Layout>
  );
}
